import { render } from "./tag_report.vue?vue&type=template&id=28944a22"
import script from "./tag_report.vue?vue&type=script&lang=js"
export * from "./tag_report.vue?vue&type=script&lang=js"

import "./tag_report.vue?vue&type=style&index=0&id=28944a22&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__